import {
	InvoiceTemplates,
	PnlGroups,
} from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import { ensureNegative, round } from '@shared/utils/math';
import { formatPercentage } from '@shared/utils/formatPercentage';
import TemplateItem from '../TemplateItem';
import HireInvoiceItem from './HireInvoiceItem';

class HIIFreightAddressCommission extends HireInvoiceItem {
	static get itemType() {
		return 'freightAddressCommission';
	}

	constructor(id, isOriginal, params) {
		super(id, isOriginal, { fixtureCurrency: params?.fixtureCurrency });

		this.cargoId = params.cargoId;
		this.percentage = params.percentage;
		this.invoiceablePercentage = params.invoiceablePercentage;
		this.maxPercentage = params.maxPercentage;

		this._showTotal = true;
		this.itemTypeLabel = 'Address Commission';
		this.addManually = false;
		this.templateSection = TemplateItem.Sections.COMMISSIONS;
		this.pnlGroup = PnlGroups.ADDRESS_COMMISSIONS;

		this._fields = {};
	}

	_calculateTotal(invoiceItems, convertCurrency) {
		const freight = this.getParent(invoiceItems);

		const finalPercentage = this.percentage * (this.invoiceablePercentage / 100);

		const totalFreight = freight.getCommissionBase(convertCurrency);

		const total = totalFreight * (finalPercentage / 100);

		return round(-1 * total, 2);
	}

	getDescription() {
		return `${formatPercentage(this.percentage, 2)}`;
	}

	static async _getClassParams(model, _parentModel) {
		const cargo = await model.getCargo();

		return {
			cargoId: cargo.id,
			percentage: model.percentage ?? cargo.addressCommission,
			invoiceablePercentage: model.invoiceablePercentage,
			maxPercentage: model.maxPercentage,
		};
	}

	async saveModel(model) {
		await super.saveModel(model);
		model.cargoId = this.cargoId;
		model.invoiceablePercentage = this.invoiceablePercentage;
		model.percentage = this.percentage;
		await model.save();
	}

	_getTemplateItemParams(invoiceItems) {
		const totalFreight = this.getParent(invoiceItems).getCommissionBase();

		return {
			[InvoiceTemplates.CLASSIC]: {
				columns: ['Address commission', `${this.getDescription()} (${this.invoiceablePercentage}%)`],
			},
			[InvoiceTemplates.NEO]: {
				columns: [
					` — Address commission (${this.invoiceablePercentage}%)`,
					`${formatPercentage(this.percentage, 2, false)}`,
					'%',
					`${formatCurrency(
						ensureNegative(totalFreight),
						this.fixtureCurrency,
						{ hideSymbol: true },
					)}`,
				],
			},
		};
	}
}

HireInvoiceItem.addItemClass(HIIFreightAddressCommission);

export default HIIFreightAddressCommission;
